import React from 'react';
import withRecipients from 'components/triggers/rule-context/WithRecipients';
import {SmartAlertContextTitle} from 'components/triggers/rule-context/SmartAlertContextTitle';
import {OverlappingCommentsIcon} from '@components/icon/OverlappingCommentsIcon';

class CoachesContext extends React.Component {
  render() {
    const {usersEmpty, renderEmbeddedContent} = this.props;
    return (
      <div className="context-container">
        <SmartAlertContextTitle icon={OverlappingCommentsIcon} onClose={this.props.removeContext}>
          <span>they comment, highlight or leave a score</span>
        </SmartAlertContextTitle>
        <div className={usersEmpty && 'initial-options'}>{renderEmbeddedContent()}</div>
      </div>
    );
  }
}

export default withRecipients(CoachesContext);
